import React from 'react'
import PropTypes from 'prop-types'

import { Button, Form, Select } from 'antd'
import { withTranslation } from 'react-i18next'

import ProjectWrapper from './project.style'

const ProjectUserTypeForm = ({
    i18n,
    customerCompanyProject,
    form,
    saving,
    onSubmitForm,
    toggleForm
}) => {
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 }
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 }
        }
    }
    const tailFormItemLayout = {
        wrapperCol: {
            xs: {
                span: 24,
                offset: 0
            },
            sm: {
                span: 16,
                offset: 8
            }
        }
    }

    const handleSubmitForm = (values) => {
        onSubmitForm(values)
    }
    return (
        <ProjectWrapper>
            <h3>{i18n.t('projects:editUserType')}</h3>
            <Form onFinish={handleSubmitForm} {...formItemLayout}>
                <Form.Item label={i18n.t('projects:userType')}
                    name='user_type'
                    initialValue={customerCompanyProject.user_type}>
                        <Select>
                            <Select.Option value="user">{i18n.t('projects:userTypes.user')}</Select.Option>
                            <Select.Option value="owner">{i18n.t('projects:userTypes.owner')}</Select.Option>
                        </Select>
                </Form.Item>

                <Form.Item className="project-form-action-btn" {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" loading={saving}>{i18n.t('shared:save')}</Button>
                    <Button htmlType="button" onClick={toggleForm}>{i18n.t('shared:close')}</Button>
                </Form.Item>
            </Form>
        </ProjectWrapper>
    )
}

ProjectUserTypeForm.propTypes = {
    customerCompanyProject: PropTypes.object,
    saving: PropTypes.bool,
    onSubmitForm: PropTypes.func.isRequired,
    toggleForm: PropTypes.func.isRequired
}

ProjectUserTypeForm.defaultProps = {
    customerCompanyProject: {},
    saving: false
}

export default withTranslation(['shared', 'projects'])(ProjectUserTypeForm)

